import config from "@Config/index";
import axios from "axios";

const fetchPriceTrends = async ({ id }: { id: any }) =>
  axios.get(`${config.API_URL}/api/v0/inventories/${id}/price_trends`);

export default fetchPriceTrends;
